export const a11yStrings = {
  enablePatterns: 'Apply pattern fill',
  disablePatterns: 'Remove pattern fill',
  showDataTable: 'View data table',
  exitDataTable: 'Exit data table',
  moreActions: 'More actions'
};